import React from "react";
import { useParams } from "react-router-dom";
import Tasks from "../TasksPages/Tasks";

export default function TeamTasks() {
  const { id: teamId } = useParams();
  return <Tasks teamId={teamId} />;
}
